<wm-email-activity-view
  *ngIf="activity"
  [isPreview]="isPreview"
  [form]="form"
  [activity]="activity"
></wm-email-activity-view>
